import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, X } from 'lucide-react';
import { Button } from '../ui/Button';
interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  streamName: string;
}
export function DeleteConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  streamName
}: DeleteConfirmModalProps) {
  return <AnimatePresence>
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.95
      }} transition={{
        duration: 0.15
      }} className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md bg-surface-900 border border-surface-600 rounded-xl shadow-2xl z-50">
            {/* Header */}
            <div className="flex items-start gap-4 p-6 border-b border-surface-600">
              <div className="w-10 h-10 rounded-xl bg-danger-500/10 flex items-center justify-center flex-shrink-0">
                <AlertTriangle className="w-5 h-5 text-danger-400" />
              </div>
              <div className="flex-1">
                <h2 className="text-lg font-semibold text-text-primary mb-1">
                  Delete Stream
                </h2>
                <p className="text-sm text-text-secondary">
                  Are you sure you want to delete "{streamName}"?
                </p>
              </div>
              <button onClick={onClose} className="text-text-muted hover:text-text-primary transition-colors">
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6">
              <div className="bg-danger-500/10 border border-danger-500/20 rounded-lg p-4">
                <p className="text-sm text-danger-300 leading-relaxed">
                  <strong className="font-semibold">
                    This action cannot be undone.
                  </strong>{' '}
                  All tasks, context, and conversation history will be
                  permanently deleted.
                </p>
              </div>
            </div>

            {/* Footer */}
            <div className="flex items-center justify-end gap-3 p-6 border-t border-surface-600 bg-surface-900/50">
              <Button variant="ghost" onClick={onClose}>
                Cancel
              </Button>
              <Button variant="danger" onClick={() => {
            onConfirm();
            onClose();
          }}>
                Delete Stream
              </Button>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}